import { NewsContentType } from '@/types/enum';
import image1 from '@/assets/images/news/detail/20210125/1.jpg';
import image2 from '@/assets/images/news/detail/20210125/2.jpg';
import image3 from '@/assets/images/news/detail/20210125/3.png';

export default {
  id: '20210125', //  模块 id
  title: '冬季防火进行时 消防安全常伴心间', // 标题
  origin: '', // 新闻来源
  editor: '', // 编辑者
  content: [
    {
      type: NewsContentType.Text,
      text:
        '去年的消防宣传日，我们组织了总部大楼第一次火灾逃生演习，过程中，小伙伴们学会了如何在遇到火灾时顺利逃生，但我们希望的是火灾永远不会发生。冬季天气干燥，极易造成火灾事故发生，我们一起看下发生在我们身边的几件事：',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '加热盒装高油脂食物造成微波炉起火',
    },
    {
      type: NewsContentType.Image,
      src: [image1, image2],
      customStyle: {
        objectFit: 'unset',
      },
    },
    {
      type: NewsContentType.Text,
      text:
        '事件经过：2020年12月午休时间，总部2号楼茶水间，某位同学在微波炉加热盒装高油脂食物造成微波炉起火。所幸的是，火情被其他小伙伴发现，及时扑灭了燃烧的纸盒，但仍然导致了微波炉报废。',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text:
        '提示：微波炉禁止加热金属及带金属包边的器皿（特别警醒锡纸类包装）、密封食品、带壳鸡蛋等不宜微波炉加热的食品。加热时勿远离现场，炉内冒烟时关紧炉门，按停止键并拔掉电源插头。',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '未熄灭烟头丢进花坛导致绿化燃烧',
    },
    {
      type: NewsContentType.Image,
      title: '',
      src: [image3],
    },
    {
      type: NewsContentType.Text,
      text:
        '事件经过：2021年1月11日晚8点，总部7号楼门口，某位同学将未熄灭的烟头丢进花坛，烟蒂点燃了花坛里干燥的绿化植物，现场火势较大。园区物业巡逻人员发现后，立即扑灭了着火草坪，所幸的是未造成更大的损害。',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text:
        '提示：出于对员工健康和办公室消防安全考虑，公司提倡无烟办公环境，大楼内（包括消防通道、卫生间）24小时全方位禁烟。有抽烟需求的同事，可到大楼外指定吸烟区域抽烟，并将烟蒂投放在灭烟筒内。',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text:
        '以上事件都在警醒着我们，火灾危险/隐患就在我们身边。哪些行为会带来消防安全隐患，我们是坚决不能做的呢？',
    },
    {
      type: NewsContentType.Text,
      text: '①严禁在大楼内抽烟。',
    },
    {
      type: NewsContentType.Text,
      text: '②不得堆放易燃易爆危险物品。',
    },
    {
      type: NewsContentType.Text,
      text:
        '③不应堵塞消防通道（含室内外），禁止私自挪用、损坏灭火器和消防设施，未经许可，禁止动火。',
    },
    {
      type: NewsContentType.Text,
      text: '④安全使用公司公共电器设备，爱护园区公共环境。',
    },
    {
      type: NewsContentType.Text,
      text:
        '⑤不可私接电源或使用大功率电器（500瓦以上），因工作原因需使用大功率设备的，应提前与行政部沟通确认。',
    },
    {
      type: NewsContentType.Text,
      text: '⑥如用电出现异常，及时联系行政部。',
    },
    {
      type: NewsContentType.Text,
      text: '⑦如因个人行为对公司造成损害，须按实际情况承担相应的责任。',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text:
        '希望小伙伴们能重视消防安全问题，将防火意识融入日常工作生活的每一步，共同创建安全稳定的工作环境。',
    },
  ],
};
